import $ from 'jquery'
adminApi.$inject = ['$http', '$q', '$timeout', 'Upload', 'configuration']

export default function adminApi($http, $q, $timeout, Upload, config) {
  var endPoint = config.apiEndPoint
  return {
    ////////////////////////////////
    // Fetching user license info //
    ////////////////////////////////
    getDomainLicensedUsers: function(domainUuid, product) {
      var deferred = $q.defer()
      $http.get(endPoint + '/analytics/report/domain/' + domainUuid + '/product/' + product).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.reject({
            status: 'error',
            message: response.data
          })
        }
      )

      return deferred.promise
    },
    getDomainUserConsolidatedActivations: function(
      domainUuid,
      schoolYear,
      products = ['toolkit', 'pathways']
    ) {
      return $http
        .get(
          `${
            config.analyticsEndPoint
          }/reports/domains/${domainUuid}/schoolYear/${schoolYear}/user_activations?${$.param({
            products: products.join(',')
          })}`
        )
        .then(response => response.data)
    },
    getDomainUseCodesReport: function(domainUuid, reportType = 'all') {
      if (['active', 'expired', 'all'].indexOf(reportType) < 0) {
        throw 'Use codes report type must be active, expired, or all'
      }
      return $http
        .get(`${endPoint}/use_codes/domain/${domainUuid}/${reportType}`)
        .then(response => response.data)
    },
    generateDomainUseCodes: function(domainUuid, userUuids, expirationDate) {
      let payload = {
        user_uuids: userUuids,
        expiration_date: expirationDate
      }
      return $http
        .post(`${endPoint}/use_codes/domain/${domainUuid}`, payload)
        .then(response => response.data)
    },
    getDomainSignupLink: function(domainUuid) {
      return $http.get(`${endPoint}/signup_link/${domainUuid}`).then(
        response => response.data,
        rejection => {
          console.error('Error while getting sign-up link: ')
          console.error(rejection)
        }
      )
    },
    getAllDomainSignupLinks: function(domainUuid) {
      return $http.get(`${endPoint}/signup_link/${domainUuid}/all`).then(
        response => response.data,
        rejection => {
          console.error('Error while getting sign-up link: ')
          console.error(rejection)
        }
      )
    },
    postSignupLink: function({
      domain_uuid,
      activation_date,
      expiration_date,
      license_end_date,
      total_capacity,
      created_by,
      notes
    }) {
      var deferred = $q.defer()
      $http
        .post(`${endPoint}/signup_link`, {
          domain_uuid,
          activation_date,
          expiration_date,
          license_end_date,
          total_capacity,
          created_by,
          notes
        })
        .then(
          response => deferred.resolve(response.data),
          rejection => {
            console.error('Error while generating sign-up link: ')
            console.error(rejection)
            deferred.reject(rejection.data)
          }
        )
      return deferred.promise
    },
    putSignupLink: function({
      signup_token,
      domain_uuid,
      activation_date,
      expiration_date,
      license_end_date,
      total_capacity,
      updated_by,
      notes
    }) {
      var deferred = $q.defer()
      $http
        .put(`${endPoint}/signup_link`, {
          signup_token,
          domain_uuid,
          activation_date,
          expiration_date,
          license_end_date,
          total_capacity,
          updated_by,
          notes
        })
        .then(
          response => deferred.resolve(response.data),
          rejection => {
            console.error('Error while updating sign-up link: ')
            console.error(rejection)
            deferred.reject(rejection.data)
          }
        )
      return deferred.promise
    },
    // Autoprovisioning API methods
    getAutoprovisioningConfig: function(domainUuid) {
      var deferred = $q.defer()
      $http.get(`${endPoint}/autoprovisioning/${domainUuid}/config`).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          // If 404, it means no config exists yet
          if (response.status === 404) {
            deferred.resolve(null)
          } else {
            console.error('Error while getting autoprovisioning config: ')
            console.error(response)
            deferred.reject(response.data)
          }
        }
      )
      return deferred.promise
    },
    saveAutoprovisioningConfig: function(domainUuid, configData) {
      var deferred = $q.defer()
      $http.post(`${endPoint}/autoprovisioning/${domainUuid}/config`, configData).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          console.error('Error while creating autoprovisioning config: ', response)
          deferred.reject(response.data)
        }
      )
      return deferred.promise
    },
    deleteAutoprovisioningConfig: function(domainUuid) {
      var deferred = $q.defer()
      $http.delete(`${endPoint}/autoprovisioning/${domainUuid}/config`).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          console.error('Error while deleting autoprovisioning config: ')
          console.error(response)
          deferred.reject(response.data)
        }
      )
      return deferred.promise
    },
    initiateAutoprovisioning: function(domainUuid, config) {
      var deferred = $q.defer()
      const url = `${endPoint}/import/${domainUuid}/initiate_autoprovision`
      
      // Use the provided config or an empty object
      const data = config || {}
      
      $http.post(url, data).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          console.error('Error while initiating autoprovisioning: ')
          console.error(response)
          deferred.reject(response.data)
        }
      )
      return deferred.promise
    },
    getLatestCSVMetadata: function(domainUuid) {
      var deferred = $q.defer()
      $http.get(`${endPoint}/autoprovisioning/${domainUuid}/latest-csv-metadata`).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          if (response.status === 404) {
            deferred.resolve(null)
          } else {
            console.error('Error while getting latest CSV metadata: ')
            console.error(response)
            deferred.reject(response.data)
          }
        }
      )
      return deferred.promise
    },
    getAutoprovisioningImportData: function() {
      var deferred = $q.defer()
      $http.get(`${endPoint}/autoprovisioning/import-data`).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          console.error('Error while getting autoprovisioning import data: ')
          console.error(response)
          deferred.reject(response.data)
        }
      )
      return deferred.promise
    },
    // Autoprovisioning Schedule API methods
    getAutoprovisioningSchedule: function(domainUuid) {
      var deferred = $q.defer()
      $http.get(`${endPoint}/autoprovisioning/${domainUuid}/schedule`).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          // If 404, it means no schedule exists yet
          if (response.status === 404) {
            deferred.resolve(null)
          } else {
            console.error('Error while getting autoprovisioning schedule: ')
            console.error(response)
            deferred.reject(response.data)
          }
        }
      )
      return deferred.promise
    },
    createAutoprovisioningSchedule: function(domainUuid, scheduleData) {
      var deferred = $q.defer()      
      $http.post(`${endPoint}/autoprovisioning/${domainUuid}/schedule`, scheduleData).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          console.error('Error while creating autoprovisioning schedule: ', response)
          deferred.reject(response.data)
        }
      )
      return deferred.promise
    },
    updateAutoprovisioningSchedule: function(domainUuid, scheduleData) {
      var deferred = $q.defer()      
      $http.put(`${endPoint}/autoprovisioning/${domainUuid}/schedule`, scheduleData).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          console.error('Error while updating autoprovisioning schedule:',response)
          deferred.reject(response.data)
        }
      )
      return deferred.promise
    },
    deleteAutoprovisioningSchedule: function(domainUuid) {
      var deferred = $q.defer()
      $http.delete(`${endPoint}/autoprovisioning/${domainUuid}/schedule`).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          console.error('Error while deleting autoprovisioning schedule: ')
          console.error(response)
          deferred.reject(response.data)
        }
      )
      return deferred.promise
    },

    // AWS Transfer Family user management
    createTransferFamilyUser: function(domainUuid, payload) {
      return $http
        .post(`${endPoint}/transfer_family/${domainUuid}/users`, payload)
        .then(response => response.data)
    },

    getTransferFamilyUser: function(domainUuid, username) {
      return $http
        .get(`${endPoint}/transfer_family/${domainUuid}/users/${encodeURIComponent(username)}`)
        .then(response => response.data)
    },

    updateTransferFamilyUser: function(domainUuid, username, payload) {
      return $http
        .put(`${endPoint}/transfer_family/${domainUuid}/users/${encodeURIComponent(username)}`, payload)
        .then(response => response.data)
    },

    deleteTransferFamilyUser: function(domainUuid, username) {
      return $http
        .delete(`${endPoint}/transfer_family/${domainUuid}/users/${encodeURIComponent(username)}`)
        .then(response => response.data)
    },
    ////////////////////////
    // Fetching user info //
    ////////////////////////
    getUserInfo: function(email, uuid) {
      var deferred = $q.defer()
      $http({
        url: `${endPoint}/user_info`,
        params: {
          email: email,
          uuid: uuid
        }
      }).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          console.log('Error: ')
          console.log(response)
          deferred.reject(response.data)
        }
      )

      return deferred.promise
    },
    /////////////////////////////
    // Fetching import records //
    /////////////////////////////
    getCompletedImports: function(limit) {
      var deferred = $q.defer()
      $http.get(endPoint + '/import/import_records/completed?' + $.param({ limit: limit })).then(
        function(response) {
          if (angular.isArray(response.data)) {
            deferred.resolve(response.data)
          } else if (response.data === 'null\n') {
            deferred.resolve([])
          }
        },
        function(response) {
          console.log('Error: ')
          console.log(response)
          deferred.resolve({
            status: 'error',
            message: response.data
          })
        }
      )

      return deferred.promise
    },
    getCompletedImportsForDomain: function(domain, limit, offset) {
      var deferred = $q.defer()
      $http
        .get(
          endPoint +
            '/import/import_records/completed/domain/' +
            domain +
            '?' +
            $.param({ limit: limit, offset: offset })
        )
        .then(
          function(response) {
            if (angular.isArray(response.data)) {
              deferred.resolve(response.data)
            } else if (response.data === 'null\n') {
              deferred.resolve([])
            }
          },
          function(response) {
            console.log('Error: ')
            console.log(response)
            deferred.resolve({
              status: 'error',
              message: response.data
            })
          }
        )

      return deferred.promise
    },
    getIncompleteImports: function() {
      var deferred = $q.defer()
      $http.get(endPoint + '/import/import_records/incomplete').then(
        function(response) {
          if (angular.isArray(response.data)) {
            deferred.resolve(response.data)
          } else if (response.data === 'null\n') {
            deferred.resolve([])
          }
        },
        function(response) {
          console.log('Error: ')
          console.log(response)
          deferred.resolve({
            status: 'error',
            message: response.data
          })
        }
      )

      return deferred.promise
    },
    deleteImport: function(importUuid) {
      var deferred = $q.defer()
      $http['delete'](endPoint + '/import/import_record/' + importUuid).then(
        function(response) {
          deferred.resolve(response.data === 'true\n')
        },
        function(response) {
          deferred.resolve({
            status: 'error',
            message: response.data
          })
        }
      )
      return deferred.promise
    },

    ///////////////////////
    // Import wizard API //
    ///////////////////////
    createImport: function(domainUuid, name, overwriteRelations) {
      var deferred = $q.defer()
      $http
        .post(endPoint + '/import/import_record', {
          domain_uuid: domainUuid,
          name: name,
          overwrite_relations: overwriteRelations
        })
        .then(
          function(response) {
            deferred.resolve(response.data)
          },
          function(response) {
            deferred.resolve({
              status: 'error',
              message: response.data
            })
          }
        )
      return deferred.promise
    },
    uploadCSV: function(importUuid, file, replaceAll, provisionDefaultLicense) {
      var deferred = $q.defer()
      var url = new URL(endPoint + '/import/import_record/' + importUuid + '/upload_csv')
      if (replaceAll) url.searchParams.append('replace_all', replaceAll)
      if (provisionDefaultLicense) url.searchParams.append('provision_default_license', provisionDefaultLicense)
      Upload.upload({
        url: url.toString(),
        file: file,
        method: 'POST'
      }).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          console.log(response)
          deferred.resolve({
            status: 'error',
            message: response.data
          })
        }
      )
      return deferred.promise
    },
    uploadUserData: function(importUuid, data, replaceAll, provisionDefaultLicense) {
      var deferred = $q.defer()
      var url = new URL(endPoint + '/import/import_record/' + importUuid + '/upload_data')
      if (replaceAll) url.searchParams.append('replace_all', replaceAll)
      if (provisionDefaultLicense) url.searchParams.append('provision_default_license', provisionDefaultLicense)
      $http.post(url.toString(), data).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          console.log(response)
          deferred.resolve({
            status: 'error',
            message: response.data
          })
        }
      )
      return deferred.promise
    },
    updateSchoolsForUserData: function(importUuid, schoolChanges) {
      var deferred = $q.defer()
      $http.post(endPoint + '/import/import_record/' + importUuid + '/update_schools', {"schools":schoolChanges}).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.resolve({
            status: 'error',
            message: response.data
          })
        }
      )
      return deferred.promise
    },
    getImportRecord: function(importUuid) {
      var deferred = $q.defer()
      $http.get(endPoint + '/import/import_record/' + importUuid).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.resolve(response.data)
        }
      )
      return deferred.promise
    },
    getImportRecordStatus: function(importUuid) {
      var deferred = $q.defer()
      $http.get(endPoint + '/import/import_record/' + importUuid + '/status').then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.resolve(response.data)
        }
      )
      return deferred.promise
    },
    startImportDiff: function(importUuid) {
      var deferred = $q.defer()
      $http.post(endPoint + '/import/import_record/' + importUuid + '/diff').then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.resolve(response.data)
        }
      )
      return deferred.promise
    },
    generateSchoolDiff: function(importUuid) {
      var deferred = $q.defer()
      $http.post(endPoint + '/import/import_record/' + importUuid + '/school_diff').then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.resolve(response.data)
        }
      )
      return deferred.promise
    },
    generateUserDiff: function(importUuid) {
      var deferred = $q.defer()
      $http.post(endPoint + '/import/import_record/' + importUuid + '/user_diff').then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.resolve(response.data)
        }
      )
      return deferred.promise
    },
    getSchoolDiff: function(importUuid) {
      var deferred = $q.defer()
      $http.get(endPoint + '/import/import_record/' + importUuid + '/school_diff').then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.resolve({
            status: 'error',
            message: response.data
          })
        }
      )
      return deferred.promise
    },
    getUserDiff: function(importUuid) {
      var deferred = $q.defer()
      $http.get(endPoint + '/import/import_record/' + importUuid + '/user_diff').then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.resolve({
            status: 'error',
            message: response.data
          })
        }
      )
      return deferred.promise
    },
    getActiveLicenses: function(importUuid) {
      var deferred = $q.defer()
      $http.get(endPoint + '/import/import_record/' + importUuid + '/active_licenses').then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.resolve({
            status: 'error',
            message: response.data
          })
        }
      )
      return deferred.promise
    },
    postActiveLicenses: function(importUuid) {
      var deferred = $q.defer()
      $http.post(endPoint + '/import/import_record/' + importUuid + '/active_licenses').then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.resolve({
            status: 'error',
            message: response.data
          })
        }
      )
      return deferred.promise
    },
    putActiveLicenses: function(importUuid, payload) {
      var deferred = $q.defer()
      $http
        .put(endPoint + '/import/import_record/' + importUuid + '/active_licenses', payload)
        .then(
          function(response) {
            deferred.resolve(response.data)
          },
          function(response) {
            deferred.resolve({
              status: 'error',
              message: response.data
            })
          }
        )
      return deferred.promise
    },
    postCommit: function(importUuid) {
      var deferred = $q.defer()
      $http.post(endPoint + '/import/import_record/' + importUuid + '/commit', {}).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.resolve({
            status: 'error',
            message: response.data
          })
        }
      )
      return deferred.promise
    },
    getCommitResult: function(importUuid) {
      var deferred = $q.defer()
      $http.get(endPoint + '/import/import_record/' + importUuid + '/commit').then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.resolve({
            status: 'error',
            message: response.data
          })
        }
      )
      return deferred.promise
    },

    ////////////////////////////
    // User batch actions API //
    ////////////////////////////
    provisionLicensesForDomainUsers: function(domainUuid, userUuids, actionData) {
      var deferred = $q.defer()
      $http
        .post(endPoint + '/import/' + domainUuid + '/provision_licenses', {
          user_uuids: userUuids,
          action_data: actionData
        })
        .then(
          function(response) {
            deferred.resolve(response.data)
          },
          function(response) {
            deferred.reject(response.data)
          }
        )
      return deferred.promise
    },

    provisionLicensesForConsumerUsers: function(userUuids, actionData) {
      var deferred = $q.defer()
      $http
        .post(endPoint + '/import/consumer/provision_licenses', {
          user_uuids: userUuids,
          action_data: actionData
        })
        .then(
          function(response) {
            deferred.resolve(response.data)
          },
          function(response) {
            deferred.reject(response.data)
          }
        )
      return deferred.promise
    },

    replaceLicensesForDomainUsers: function(domainUuid, userUuids, actionData) {
      var deferred = $q.defer()
      $http
        .post(endPoint + '/import/' + domainUuid + '/replace_licenses', {
          user_uuids: userUuids,
          action_data: actionData
        })
        .then(
          function(response) {
            deferred.resolve(response.data)
          },
          function(response) {
            deferred.reject(response.data)
          }
        )
      return deferred.promise
    },

    editUserInfo: function(userUuids, actionData) {
      var deferred = $q.defer()
      $http
        .post(endPoint + '/import/edit_user_info', {
          user_uuids: userUuids,
          action_data: actionData
        })
        .then(
          function(response) {
            deferred.resolve(response.data)
          },
          function(response) {
            deferred.reject(response.data)
          }
        )
      return deferred.promise
    },

    editAccount: function(userUuid, accountInfo) {
      var deferred = $q.defer()
      $http
        .put(endPoint + '/user_info/account', { user_uuids: [userUuid], action_data: accountInfo })
        .then(
          function(response) {
            deferred.resolve(response.data)
          },
          function(response) {
            deferred.reject(response.data)
          }
        )
      return deferred.promise
    },
    batchUpdateAccounts: (userUuids, fieldsToUpdate) => {
      return $http
        .put(`${endPoint}/user_info/account/batch`, {
          user_uuids: userUuids,
          update_fields: fieldsToUpdate
        })
        .then(
          response => {
            return response.data
          },
          response => {
            return response.data
          }
        )
    },

    batchUpdateProductAccounts: (product, userUuids, fieldsToUpdate) => {
      if (product !== 'toolkit' && product !== 'pathways') {
        throw `Unknown product ${product}`
      }

      let url = `${endPoint}/user_info/${
        product === 'toolkit' ? 'toolkit_account' : 'atlas_account'
      }/batch`
      return $http
        .put(url, {
          user_uuids: userUuids,
          update_fields: fieldsToUpdate
        })
        .then(
          response => {
            return response.data
          },
          response => {
            return response.data
          }
        )
    },

    putToolkitUsers: function(userUuids, actionData) {
      var deferred = $q.defer()
      $http
        .put(endPoint + '/user_info/toolkit_account', {
          user_uuids: userUuids,
          action_data: actionData
        })
        .then(
          function(response) {
            deferred.resolve(response.data)
          },
          function(response) {
            console.log('Error: ')
            console.log(response)
            deferred.reject(response.data)
          }
        )
      return deferred.promise
    },

    putPathwaysUsers: function(userUuids, actionData) {
      var deferred = $q.defer()
      $http
        .put(endPoint + '/user_info/atlas_account', {
          user_uuids: userUuids,
          action_data: actionData
        })
        .then(
          function(response) {
            deferred.resolve(response.data)
          },
          function(response) {
            console.log('Error: ')
            console.log(response)
            deferred.reject(response.data)
          }
        )
      return deferred.promise
    },
    getMontlyQuotas: function(userUuid, actionData) {
      var deferred = $q.defer()
      $http.get(endPoint + '/user_info/monthly_quotas?uuid=' + encodeURIComponent(userUuid)).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          console.log('Error: ')
          console.log(response)
          deferred.reject(response.data)
        }
      )
      return deferred.promise
    },
    postMonthlyQuotas: function(userUuid, actionData) {
      var deferred = $q.defer()
      $http
        .post(
          endPoint + '/user_info/monthly_quotas?uuid=' + encodeURIComponent(userUuid),
          actionData
        )
        .then(
          function(response) {
            deferred.resolve(response.data)
          },
          function(response) {
            console.log('Error: ')
            console.log(response)
            deferred.reject(response.data)
          }
        )
      return deferred.promise
    },
    deleteUsers: function(userUuids, actionData) {
      var deferred = $q.defer()
      $http
        .post(endPoint + '/import/delete_users', { user_uuids: userUuids, action_data: actionData })
        .then(
          function(response) {
            deferred.resolve(response.data)
          },
          function(response) {
            deferred.reject(response.data)
          }
        )
      return deferred.promise
    },

    addUsersToSchools: function(userUuids, schoolUuids, domainUuid, { allowMultipleSchools }) {
      var deferred = $q.defer()
      var actionData = {
        school_uuids: schoolUuids.join(','),
        domain_uuid: domainUuid
      }
      if (allowMultipleSchools) {
        actionData.replace_existing_school = 'false'
      }
      $http
        .post(endPoint + '/import/add_users_to_schools', {
          user_uuids: userUuids,
          action_data: actionData
        })
        .then(
          function(response) {
            deferred.resolve(response.data)
          },
          function(response) {
            deferred.reject(response.data)
          }
        )
      return deferred.promise
    },

    addUsersToDomain: function(userUuids, domainUuid) {
      var deferred = $q.defer()
      var actionData = {
        domain_uuid: domainUuid
      }
      $http
        .post(endPoint + '/import/add_users_to_domain', {
          user_uuids: userUuids,
          action_data: actionData
        })
        .then(
          function(response) {
            deferred.resolve(response.data)
          },
          function(response) {
            deferred.reject(response.data)
          }
        )
      return deferred.promise
    },

    removeUsersFromSchools: function(userUuids, schoolUuids, domainUuid) {
      var deferred = $q.defer()
      var actionData = {
        school_uuids: schoolUuids.join(','),
        domain_uuid: domainUuid
      }
      $http
        .post(endPoint + '/import/remove_users_from_schools', {
          user_uuids: userUuids,
          action_data: actionData
        })
        .then(
          function(response) {
            deferred.resolve(response.data)
          },
          function(response) {
            deferred.reject(response.data)
          }
        )
      return deferred.promise
    },

    removeUsersFromDomain: function(userUuids, domainUuid) {
      var deferred = $q.defer()
      var actionData = {
        domain_uuid: domainUuid
      }
      $http
        .post(endPoint + '/import/remove_users_from_domain', {
          user_uuids: userUuids,
          action_data: actionData
        })
        .then(
          function(response) {
            deferred.resolve(response.data)
          },
          function(response) {
            deferred.reject(response.data)
          }
        )
      return deferred.promise
    },

    deleteLicensesForUsers: function(userUuids, domainUuid) {
      var deferred = $q.defer()
      var actionData = {
        domain_uuid: domainUuid
      }
      $http
        .post(endPoint + '/import/delete_licenses_for_users', {
          user_uuids: userUuids,
          action_data: actionData
        })
        .then(
          function(response) {
            deferred.resolve(response.data)
          },
          function(response) {
            deferred.reject(response.data)
          }
        )
      return deferred.promise
    },

    resetPasswordsForUsers: function(userUuids, password, domainUuid) {
      var deferred = $q.defer()
      var actionData = {
        password: password,
        domain_uuid: domainUuid
      }
      $http
        .put(endPoint + '/import/reset_user_password', {
          user_uuids: userUuids,
          action_data: actionData
        })
        .then(
          function(response) {
            deferred.resolve(response.data)
          },
          function(response) {
            deferred.reject(response.data)
          }
        )
      return deferred.promise
    },

    manageTags: function(userUuids, actionData) {
      var deferred = $q.defer()
      $http
        .put(endPoint + '/user_info/manage_tags', {
          user_uuids: userUuids,
          action_data: actionData
        })
        .then(
          function(response) {
            deferred.resolve(response.data)
          },
          function(response) {
            console.error('Error: ')
            console.error(response)
            deferred.reject(response.data)
          }
        )
      return deferred.promise
    },
    // Identity Provider
    getIdentityProvider: function(providerId) {
      var deferred = $q.defer()
      $http.get(endPoint + '/identity_providers/' + providerId).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.reject(response.data)
        }
      )
      return deferred.promise
    },
    getIdentityProvidersList: function() {
      var deferred = $q.defer()
      $http.get(endPoint + '/identity_providers').then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.reject(response.data)
        }
      )
      return deferred.promise
    },

    // scrambler API
    uploadScrambleCSV({ file, notes }) {
      return Upload.upload({
        url: `${endPoint}/scrambler/upload_csv?async=1`,
        data: {
          csv: file,
          notes: notes
        },
        method: 'POST'
      }).then(
        resp => {
          return resp.data
        },
        resp => {
          throw resp.data
        }
      )
    },
    getScrambleRecords(params) {
      return $http.get(`${endPoint}/scrambler/records`, { params }).then(
        resp => {
          return resp.data
        },
        resp => {
          throw resp.data
        }
      )
    },
    getScrambleRecord(id) {
      return $http.get(`${endPoint}/scrambler/records/${id}`).then(
        resp => {
          return resp.data
        },
        resp => {
          throw resp.data
        }
      )
    },
    deleteScrambleRecord(id) {
      return $http.delete(`${endPoint}/scrambler/records/${id}`).then(
        resp => {
          return resp.data
        },
        resp => {
          throw resp.data
        }
      )
    },
    postUserRBACRole(email, role) {
      return $http
        .post(`${endPoint}/user/rbac_role`, {
          email: email,
          role: role
        })
        .then(
          resp => {
            return resp.data
          },
          resp => {
            throw resp.data
          }
        )
    },
    deleteUserRBACRole(email, role) {
      return $http
        .delete(`${endPoint}/user/rbac_role`, {
          data: {
            email: email,
            role: role
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(
          resp => {
            return resp.data
          },
          resp => {
            throw resp.data
          }
        )
    },
    mergeSchools: function(sourceSchoolUuid, targetSchoolUuid, domainUuid) {
      var deferred = $q.defer()
      $http.post(endPoint + '/schools/merge', {
        source_school_uuid: sourceSchoolUuid,
        target_school_uuid: targetSchoolUuid,
        domain_uuid: domainUuid
      }).then(
        function(response) {
          deferred.resolve(response.data)
        },
        function(response) {
          deferred.reject(response.data)
        }
      )
      return deferred.promise
    }
  }
}
